import { Component } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
	selector: 'page-ebooks',
	templateUrl: 'ebooks.html',
})

export class EbooksPage {

	displayData: boolean = false;
	eBookList: Array<{ name:string, url: string, }>;

	constructor(
		private iab: InAppBrowser) {
	}

	ionViewDidLoad() {
		this.eBookList = [
			{ name: '5 Steps to eLearning Success', url: 'https://www.ecomscotland.com/resources/ebook-5-steps-to-elearning-success/' },
			{ name: 'Competency Management – Pathway to Performance', url: 'https://www.ecomscotland.com/resources/ebook-competency-management-pathway-to-performance/' },
			{ name: 'The right kind of question', url: 'https://www.ecomscotland.com/resources/ebook-the-right-kind-of-question/' },
			{ name: 'Using online assessment to manage compliance', url: 'https://www.ecomscotland.com/resources/ebook-using-online-assessment-to-manage-compliance/' },
			{ name: '5 Steps to Digital Transformation Success', url: 'https://www.ecomscotland.com/resources/ebook-5-steps-to-digital-transformation-success/' }
		];

		this.displayData = true;
	}

	openURL(url){
		this.iab.create(url, '_system');
	}
}


// WEBPACK FOOTER //
// ./src/pages/ebooks/ebooks.ts